import { Observable, of, switchMap } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseModel } from '@app/core/models/response.model';
import { environment } from '@env/environment';
import { SupportTicketResponse } from '@app/modules/account/support/models/ticket.model';

export interface SupportTicket {
	motive: string;
	description: string;
	date: string;
	location: string;
	affectedUser: string;
	trackingCode?: string;
	additionalInfo?: string;
	attachment?: File;
}

// export interface SupportTicketResponse {
// 	id: number;
// 	motive: string;
// 	description: string;
// 	date: string;
// 	location: string;
// 	affectedUser: string;
// 	trackingCode?: string;
// 	additionalInfo?: string;
// 	status: string;
// 	attachmentUrl?: string;
// 	createdAt: Date;
// 	updatedAt: string;
// }

@Injectable()
export class SupportService {
	private URL: string = environment.apiUrl + 'support/';

	constructor(private http: HttpClient) {}

	/**
	 * Creates a new support ticket
	 * @param ticket Support ticket data
	 * @param attachment Optional file attachment
	 * @returns Observable with the result of the operation
	 */
	createTicket(ticket: SupportTicket, attachment?: File): Observable<any> {
		const formData = new FormData();

		// Append all ticket fields to formData
		Object.keys(ticket).forEach((key) => {
			if (
				key !== 'attachment' &&
				ticket[key as keyof SupportTicket] !== undefined
			) {
				formData.append(key, ticket[key as keyof SupportTicket] as string);
			}
		});

		// Append the attachment if available
		if (attachment) {
			formData.append('attachment', attachment, attachment.name);
		}

		return this.http.post(`${this.URL}create-ticket`, formData).pipe(
			switchMap((response: any) => {
				const res = response as ResponseModel<any>;
				return of(res.data);
			}),
		);
	}

	/**
	 * Gets all tickets for the current user
	 * @returns Observable with the list of user tickets
	 */
	getUserTickets(): Observable<SupportTicketResponse[]> {
		return this.http
			.get<ResponseModel<SupportTicketResponse[]>>(`${this.URL}user-tickets`)
			.pipe(
				switchMap((response: ResponseModel<SupportTicketResponse[]>) => {
					return of(response.data);
				}),
			);
	}

	/**
	 * Gets a list of available support categories/motives
	 * @returns Observable with the list of support categories
	 */
	getSupportCategories(): Observable<string[]> {
		// This would typically call an API endpoint
		// For now returning a static list that matches the requirements
		return of([
			'Tuve un problema técnico',
			'Tengo una duda o necesito ayuda',
			'Quiero reportar una situación',
			'Necesito una mejora',
			'Otro motivo',
		]);
	}

	/**
	 * Gets a list of application modules/locations
	 * @returns Observable with the list of application modules
	 */
	getApplicationModules(): Observable<string[]> {
		// This would typically call an API endpoint
		// For now returning a static list of common modules
		return of([
			'Publicar Carga',
			'Mapa',
			'Login',
			'Registro',
			'Perfil',
			'Pagos',
			'Contratos',
			'Otro',
		]);
	}
}

